import React from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { ROUTE_PATHS } from 'constants/index'
import Footer from '../Footer/index'
import './mainLayout.scss'

const MainLayout = ({ showFooter, children }) => {
  const { showSideNav, showChat, showNotification } = useSelector(
    (state) => state?.settings
  )
  const location = useLocation()

  const isPredictionMarket = location.pathname === ROUTE_PATHS.predictionMarket ||
    location.pathname.startsWith(`${ROUTE_PATHS.predictionMarket}/`)

  return (
    <>
      <div
        className={` ${!showSideNav ? 'sidebar-close' : ''}
          ${(showChat || showNotification) && !isPredictionMarket ? 'chat-parent chat-active' : ''}
          ${isPredictionMarket ? 'prediction-market-layout' : ''}`}
      >
        <div
          className={`content-wrapper
            ${isPredictionMarket ? 'prediction-market-wrap' : 'custom-spacer'}`}
          style={{ minHeight: isPredictionMarket ? 'calc(100vh - 56px)' : 'calc(100vh - 482px)' }}
        >
          {children}
        </div>
        {showFooter ? <Footer /> : <></>}
      </div>
    </>
  )
}

export default MainLayout
